import type { ReactNode } from "react";
import type { GDSStyleObject } from "@leagueplatform/genesis-core";
import { Box, UtilityText } from "@leagueplatform/genesis-core";

type UnreadMessageIndicatorProps = {
  unreadMessageCount: number;
  children: ReactNode;
  css?: GDSStyleObject;
};

export function UnreadMessageIndicator({
  unreadMessageCount,
  children,
  css,
}: UnreadMessageIndicatorProps) {
  return (
    <Box
      css={{
        position: "relative",
        width: "fit-content",
        ...css,
      }}
    >
      {unreadMessageCount > 0 ? (
        <Box
          css={{
            // Sit the badge on the top-right corner of the child bubble
            // rather than floating fully outside it — the child is the
            // 56px chat bubble Button and this positioning gives the
            // badge ~25% peek above/right, matching the standard
            // notification-badge pattern (Figma spec + iOS parity).
            position: "absolute",
            top: 0,
            right: 0,
            transform: "translate(25%, -25%)",
            borderRadius: "50%",
            backgroundColor: "$tagCriticalBackgroundBold",
            pointerEvents: "none",
            width: 23,
            height: 23,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <UtilityText
            aria-hidden
            css={{
              typography: "$caption",
              color: "$tagCriticalTextBold",
            }}
          >
            {unreadMessageCount}
          </UtilityText>
        </Box>
      ) : null}
      {children}
    </Box>
  );
}
